var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nb-text-area',{attrs:{"label":_vm.answerBlockData.label,"placeholder":_vm.answerBlockData.label,"info":_vm.answerBlockData.info,"fit":_vm.fit,"rows":10,"maxlength":_vm.getMaxlength(_vm.answerBlockData.character_limit)},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }